import {
  setCookie, getCookie,
} from './utils';

export interface TrackedInfo {
  hovrEngaged: boolean;
  hovrEngagedDate: string | null;
  hovrFirstEngagedDate: string | null;
  hovrSessionId: string | null;
  thirtyDayTrackingID: string | null;
  siteId: string | null;
}

export async function storeData({
  thirtyDayTrackingID,
  sessionID,
  hovrEngaged,
  hovrEngagedDate,
  hovrFirstEngagedDate,
  siteId,
}: {
  thirtyDayTrackingID?: string | null;
  sessionID: string | null;
  hovrEngaged: boolean;
  hovrEngagedDate?: string;
  hovrFirstEngagedDate?: string;
  siteId: string | null;
}): Promise<void> {
  setCookie('hovrEngaged', hovrEngaged.toString());
  if (hovrEngagedDate) {
    setCookie('hovrEngagedDate', hovrEngagedDate);
  } else if (hovrEngaged) { // only set if engaged
    setCookie('hovrEngagedDate', new Date().toISOString());
  }
  if (hovrFirstEngagedDate) {
    setCookie('hovrFirstEngagedDate', hovrFirstEngagedDate);
  }
  if (sessionID) {
    setCookie('hovrSessionId', sessionID);
  }
  if (thirtyDayTrackingID) {
    setCookie('thirtyDayTrackingId', thirtyDayTrackingID);
  }
  if (siteId) {
    setCookie('siteId', siteId);
  }
}

export async function getData(): Promise<TrackedInfo> {
  const hovrEngaged = getCookie('hovrEngaged') as boolean;
  const hovrEngagedDate = getCookie('hovrEngagedDate', false) as string;
  const hovrFirstEngagedDate = getCookie('hovrFirstEngagedDate', false) as string;
  const hovrSessionId = getCookie('hovrSessionId', false) as string | null;
  const thirtyDayTrackingID = getCookie('thirtyDayTrackingId', false) as string | null;
  const siteId = getCookie('siteId', false) as string | null;
  return {
    hovrEngaged,
    hovrEngagedDate,
    hovrFirstEngagedDate,
    hovrSessionId,
    thirtyDayTrackingID,
    siteId,
  };
}
